import { Divider, Text1, Text4, skinVars } from '@telefonica/mistica';
import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';

export interface BillingCycleData {
    BillingCycle: string;
    closing: string;
}

export const BillingCycle: React.FC<BillingCycleData> = ({ BillingCycle, closing }: BillingCycleData) => {
    const { t } = useTranslation();

    return (
        <div className='BillingCycle'>
            <div className='BillingCycle__date'>
                <div className='BillingCycle__date-title'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('billingClyce')}
                    </Text1>
                </div>
                <Text4 regular>{BillingCycle}</Text4>
            </div>
            <div className='BillingCycle__divider'>
                <Divider></Divider>
            </div>
            <div className='BillingCycle__days'>
                <div className='BillingCycle__days-title'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('billingCycleClose')}
                    </Text1>
                </div>
                <Text4 regular>{closing}</Text4>
            </div>
        </div>
    );
};

export default BillingCycle;
